export function getApp() {
  return {};
}
